import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ReplenishmentArticle,
  ReplenishmentDto,
  ReplenishmentListSettings,
} from '@epicuro-next/models/cmi';

import { REPLENISHMENT_API_TOKEN } from '../tokens';

@Injectable({
  providedIn: 'root',
})
export class ReplenishmentsService {
  constructor(
    @Inject(REPLENISHMENT_API_TOKEN) private replenishmentApiUrl: string,
    private httpClient: HttpClient,
  ) {}

  public getReplenishments(accountId: string) {
    return this.httpClient.get<ReplenishmentDto>(
      `${this.replenishmentApiUrl}/${accountId}`,
    );
  }

  public patchReplenishment(
    accountId: string,
    payload: ReplenishmentArticle[],
  ) {
    return this.httpClient.patch<ReplenishmentDto>(
      `${this.replenishmentApiUrl}/${accountId}`,
      payload,
    );
  }

  public getReplenishmentsSetting(externalAccountId: string) {
    return this.httpClient.get<ReplenishmentListSettings>(
      `${this.replenishmentApiUrl}/${externalAccountId}/settings`,
    );
  }

  public setReplenishmentsSetting(
    externalAccountId: string,
    settings: ReplenishmentListSettings,
  ) {
    return this.httpClient.put<ReplenishmentListSettings>(
      `${this.replenishmentApiUrl}/${externalAccountId}/settings`,
      settings,
    );
  }
}
